<script>
    import { forgotUserPassword } from '/public/services/users/users';        
    import ThexaHero from '/shared/c/logo/ThexaHero.svelte';

    let processed = false;

    let email = null;
    let isDoing = false;

    function processForgottenPassword(e) {
        isDoing = true;

        e.preventDefault();

        processed = false;

        forgotUserPassword({
            email: email
        }).then(res => {
            isDoing = false;
            
            if (res.success) {
                processed = true;
            }


        });

    }
</script>


<div class="">
    
    <ThexaHero/>

    {#if processed === true}

        <h4 class='text-center mb-5'>
            Password reset initiated
        </h4>
        <p class='mb-5 text-center'>
            You should receive an email shortly with instructions on how to reset your password.
        </p>
        <div class='d-grid'>
            <a href='/' class='btn btn-primary btn-lg'>
                Back to login
            </a>
        </div>        

    {:else}

        {#if isDoing === true}

            <div class='text-center mt-5 mb-5'>
                <h4>
                    <span class='ajax-ball-loader'></span>
                </h4>
            </div>


        {:else}

            <h4 class='text-center mb-5'>
                Reset your password
            </h4>

            <p class='mb-3 text-center'>
                Enter the email you use to login to THEXA and we'll send you a link to get you back into your account.
            </p>

            <form on:submit={processForgottenPassword}>
                <div class="row mb-5">                   
                    <div class="col-sm-12">
                        <input 
                            type="email" 
                            class="form-control" 
                            required bind:value={email} 
                            placeholder="Email"                            
                        />
                    </div>
                </div>
                <div class="row mb-5">
                    <div class="col-sm-12">
                        <div class='d-grid'>
                            <button type="submit" class="btn btn-primary btn-lg">
                                Send link
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            <div class='text-center mb-5'>
                <a href='/'>
                    Back to login
                </a>
            </div>


        {/if}

    {/if}        

</div>